import React                   from 'react'
import { connect }             from 'react-redux'
import {mapDispatchToProps} from "../mapDispatchToProps"
import EmptyApp from './applications/EmptyApp'
import ListApp from './applications/ListApp'
import HeaderApp from './applications/HeaderApp'
import DeleteApp from './applications/DeleteApp'
import withBaseComponent from '../withBaseComponent';
import Loading from '../common/Loading'

class Application extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.state = {
      isProcessing: false,

      mdlDel: false,
      mdlDelName: '',
    }

    this.toggleDel = this.toggleDel.bind(this);
    this.deleteApp = this.deleteApp.bind(this);
    this.renderApp = this.renderApp.bind(this);
  }

  toggleDel(token){
    this.setState(prevState => ({
      mdlDelName: token.name,
      modalDeleteApplicationId: token.id,
      mdlDel: !prevState.mdlDel
    }))
  }

  deleteApp(){
    if(typeof this.state.modalDeleteApplicationId === "undefined" || this.state.modalDeleteApplicationId === ""){
      return;
    }

    this.setState({isProcessing: true})
    this.props.userActions.deleteApplication(this.state.modalDeleteApplicationId).then(res => {
      this.setState(() => ({
        mdlDel: false,
        isProcessing: false
      }));
      this.props.userActions.applications();
      return res;
    }).catch((error) => {
      this.setState({isProcessing: false})
      return error;
    });
  }

  componentWillMount() {
    Promise.all([
      this.props.userActions.applications()
    ]).then(res => {
        this.props.screenActions.screenLoading(false)
    });
  }

  renderApp(){
    if(!this.props.applications){
      return null;
    }

    if(!this.props.applications.length){
      return <EmptyApp />
    }else {
      return <ListApp applications={this.props.applications} toggleDelete={this.toggleDel} />
    }
  }

  render() {
    if (this.props.isLoading) {
      return <Loading className="fa-7x loading" />;
    }

    const { isProcessing } = this.state;
    return (
      <div className="application-container small-container">
        <HeaderApp />

        <div className="row">
          {this.renderApp()}
        </div>

        <DeleteApp isOpen={this.state.mdlDel} toggle={this.toggleDel} className={this.props.className}
                   name={this.state.mdlDelName} isProcessing={isProcessing}
                   cancel={this.toggleDel} submit={this.deleteApp} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.screen.get('isLoading'),
    applications: state.user.get('applications') || [],
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Application)
